<script setup lang="ts">
import CardCarousel from '@Shared/components/visuals/CardCarousel.vue';
import VerbatimCard from '@Shared/components/visuals/skeletons/parts/VerbatimCard.vue';

import { Card } from '@Shared/types/portal/dashboard';

const props = defineProps<{
  hasNoData?: boolean;
}>();

const cards = computed(
  () =>
    [
      {
        idField: '1',
        hasNoData: props.hasNoData,
      },
      {
        idField: '2',
        hasNoData: props.hasNoData,
      },
      {
        idField: '3',
        hasNoData: props.hasNoData,
      },
      {
        idField: '4',
        hasNoData: props.hasNoData,
      },
      {
        idField: '5',
        hasNoData: props.hasNoData,
      },
      {
        idField: '6',
        hasNoData: props.hasNoData,
      },
      // force the cast, we should clean this up later, but it's fine for skeletons
    ] as unknown[] as Card[]
);
</script>
<template>
  <!-- we need a wrapper div, because else the v-bind on the visual component will apply to the first child too
       thus overriding the cards to [] (showing no cards). -->
  <div>
    <card-carousel
      title=""
      :card-template="VerbatimCard"
      :duration-in-milliseconds="-1"
      :max-number-of-cards-to-show="5"
      :cards="cards"
    ></card-carousel>
  </div>
</template>
